import { Injectable } from '@angular/core';
import { DataService } from 'projects/Autofacets-Core/src/app/services/data.service';
import { Urls } from 'projects/Autofacets-Core/src/app/utils/urls';
import { GenericResponse } from '../business-entities/generic-response';
import { VehiclePickupDrop } from '../business-entities/vehicle-pickup-drop';

@Injectable({
  providedIn: 'root'
})
export class VehiclePickdropListService {

  constructor(private dataProvider : DataService) { }
  async getVehiclePickDropList(data):Promise<GenericResponse<Array<VehiclePickupDrop>>>{
    return this.dataProvider.Post<GenericResponse<Array<VehiclePickupDrop>>>(Urls.GetVehiclePickDropList,data).toPromise();
  }
}
